<template>
  <div class="container suggested-tags">
    <div v-if="storeErrors['suggestedTags']" class="error-message">{{storeErrors['suggestedTags']}}</div>
    <div v-else-if="!suggestedTags || !suggestedTags.length" class="empty-response">no suggested tags</div>
    <div v-else class="table-container flip-scrollbar-parent">
      <div  class="table-wrapper flip-scrollbar-child">
        <table>
          <thead>
            <th></th>
            <th>brand tag</th>
            <th>retailer</th>
            <th class="hide-for-small">state</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="(suggestion, index) in suggestedTags" :key="index">
              <td>
                <div class="delete-link" @click="$emit('updateTag', 'blacklist', suggestion.id, suggestion.merchant_id)">x</div>
              </td>
              <td>{{suggestion.name}}</td>
              <td>{{suggestion.retailer}}</td>
              <td class="hide-for-small">{{suggestion.state}}</td>
              <td>
                <div class="button" @click="$emit('updateTag', 'claim', suggestion.id, suggestion.merchant_id)">this is me</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'SuggestedTags',

    computed: {
      ...mapState([
        'storeErrors',
        'suggestedTags'
      ])
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.suggested-tags
  .table-container
    overflow: auto
    @media only screen and (max-width: 64em)
      display: flex
      justify-content: center

  .table-wrapper
    max-height: 250px
    width: 100%

  table
    margin: 0 auto
    width: 90%

    th
      background: white
      padding: 0 .5rem .5rem .5rem
      position: sticky
      top: 0

    td
      padding: .6rem .5rem

    th:first-child, td:first-child
      padding-right: 0

    td:last-child
      padding: 0 .75rem

    th:nth-child(2)
      text-align: left

  .button
    border: 1px solid $primary-color
    font-size: .9rem
    margin: auto
    padding: .075rem .15rem
    text-align: center
    width: 65px
</style>